export class DiagnoseModel {
    diagnose: string;
    midOfficeDiagnoseTypeId: any;
    cdICDDiagnose: any;
    cdICDCode: string;
    diagnosis: string;
    medicalInformation: string;
    medicalHistory: string;
    nameOfGeneralPractioner: string;
    cityOfGeneralPractitioner: string;
    cdPhonenumberofSpecialist: string;
    cdNameofSpecialist: string;
    cdPhonenumberForeignSpecialist: string;
    nameSpecialist: string;
    hospitalinNL: string;
    phoneNumber: string;
    hasPermission: boolean;
    hospital: string;
    mediacalComments: string;
    hasMedicalReport: string;
    hasFitFlyDocument: string;
    cdCanSendDocuments: string;
    extraInformationComments: string;
    manualIcdDiagnose: string;
    isCategoryDiagnose: boolean;
    creationDate : Date;
}